import "./TabHighlight.css";

const TabHighlight: React.FC = () => {
  return <div id="tabHighlight" />;
};

export default TabHighlight;
